import { Component } from '@angular/core';

@Component({
  selector: 'app-skeleton-contacts-row',
  templateUrl: './skeleton-contacts-row.component.html',
  styleUrls: ['./skeleton-contacts-row.component.scss'],
  standalone: false
})
export class SkeletonContactsRowComponent {}
